import {FC} from "react";
import {site} from "../constants/global";

interface Props {
    booking: Booking,
    setBooking:Function,
    content: Content
}

const Footer: FC<Props> = ({ booking, setBooking, content}) => {
    return (
        <div className={'js-header'}>
            <div className={'watermark'}>
                <img src={site + "/wp-content/themes/mechanum/dist/img/watermark.png"} alt="Mechanum" />
            </div>
        </div>
    );
};
export default Footer
